import Home from "./components/Home.vue"
import Qiancai from "./components/Qiancai.vue"
import Mizhi from "./components/Mizhi.vue"
import Huiyu from "./components/Huiyu.vue"
import Baizhi from "./components/Baizhi.vue"
import Jiuzhang from "./components/Jiuzhang.vue"
import Liangtang from "./components/Liangtang.vue"
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        {
            path: "/",
            redirect: "/home"
        },
        {
            path: "/home",
            component: Home
        },
        {
            path: "/qiancai",
            component: Qiancai
        },
        {
            path: "/mizhi",
            component: Mizhi
        },
        {
            path: "/huiyu",
            component: Huiyu
        },
        {
            path: "/baizhi",
            component: Baizhi
        },
        {
            path: "/baizhi",
            component: Baizhi
        },
        {
            path: "/jiuzhang",
            component: Jiuzhang
        },
        {
            path: "/liangtang",
            component: Liangtang
        }
    ]
})